import React from 'react';

import { UiKit } from 'components';
import { useRequestReasonToggle } from '../context';

export default function Switch({ label = '' }) {
  const { isActive, isProcessing, onToggle } = useRequestReasonToggle();

  return (
    <UiKit.Toggle
      direction="rtl"
      label={label}
      isActive={isActive}
      disabled={isProcessing}
      onChange={onToggle}
    />
  );
}
